const config = {
    id: 6,
    name: "返回顶部",
    type: 1,
    module_code: "back_top",
    icon: "icon-tms-split_line",
    font_icon: "&#xe6ca;",
    style_type: 1,
    link_type: 0,
    property_data: {
        text: "返回顶部",
        position: "rb",
        left: "10",
        right: "10",
        top: "50",
        bottom: "50",
        width: "50",
        scrollY: 300
    }
};
export default config;